import { ActionBarItem } from '@workwave-tidal/core/components/ActionBar'
import { Close } from '@workwave-tidal/core/icons'
import { useFormatSeconds } from '@/hooks'
import { ModalHeader } from '@/components/Modal'

import { useTexts } from '../useTexts'
import { useController } from '../hooks/useController'

function BulkHeader() {
  const texts = useTexts()
  const {
    close,
    data: { selectedOrders },
  } = useController()

  return (
    <ModalHeader
      title={texts.titleBulk}
      actions={[<ActionBarItem icon={<Close />} key="close" onClick={close} label="" />]}
      subtitle={texts.subtitleBulk(selectedOrders.length)}
    />
  )
}

function SingleHeader() {
  const texts = useTexts()
  const {
    close,
    data: { selectedOrders },
  } = useController()

  const {
    orderStep,
    orderStepType,
    order: { name },
  } = selectedOrders[0]

  return (
    <ModalHeader
      title={texts.title(orderStepType)}
      actions={[<ActionBarItem icon={<Close />} key="close" onClick={close} label="" />]}
      subtitle={texts.subtitle({ name, serviceTime: useFormatSeconds(orderStep.serviceTimeSec) })}
    />
  )
}

export function InvalidHeader() {
  const texts = useTexts()
  const { close } = useController()

  return (
    <ModalHeader
      title={texts.emptyOrdersTitle}
      actions={[<ActionBarItem icon={<Close />} key="close" onClick={close} label="" />]}
    />
  )
}

export function Header() {
  const {
    invalid,
    data: { mode },
  } = useController()

  if (invalid) return <InvalidHeader />

  return mode === 'bulk' ? <BulkHeader /> : <SingleHeader />
}
